const KeenSlider = window.KeenSlider
const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class CardCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
    this.setupDots()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: true,
        mode: 'snap',
        origin: 'center',
        slides: {
          perView: 1.1,
          spacing: 10,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.1,
              spacing: 10,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 3.1,
              spacing: 20,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 4,
              spacing: 20,
            },
          },
        },
        slideChanged: (slider) => this.updateActiveDot(slider),
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }

  setupDots () {
    const dotsContainer = this.els.dots.element
    const slides = this.els.slide.elements.length

    for (let i = 0; i < slides; i++) {
      const dot = document.createElement('button')
      dot.classList.add('sec-CardCarousel_Dot')
      if (i === 0) dot.classList.add('sec-CardCarousel_Dot-active')

      dot.addEventListener('click', () => {
        this.carousel.moveToIdx(i)
      })

      dotsContainer.appendChild(dot)
    }
  }

  updateActiveDot (slider) {
    const activeSlide = slider.track.details.rel

    const dotsContainer = this.els.dots.element
    dotsContainer
      .querySelectorAll('.sec-CardCarousel_Dot')
      .forEach((dot, index) => {
        dot.classList.toggle(
          'sec-CardCarousel_Dot-active',
          index === activeSlide,
        )
      })
  }
}

if (!customElements.get('card-carousel')) {
  customElements.define('card-carousel', CardCarousel)
}
